<h1 [translateParams]="{ folder: context.data.parent?.displayName }"
    matDialogTitle
    translate>{{
        isNewEntry
            ? isRoot
                ? 'upsert_folder_new_first_level'
                : 'upsert_folder_new_subfolder_in'
            : 'upsert_folder_edit_folders'
}}</h1>

<form [formGroup]="form"
      (submit)="onSubmit()">

    <mat-dialog-content class="folder-modal-container">
        <mat-form-field>
            <input [uiAutofocus]
                   [placeholder]="'upsert_folder_form_name' | translate"
                   matInput
                   required
                   formControlName="displayName"
                   class="form-control"
                   data-cy="folder-name" />
            <mat-hint *ngIf="!form.get('displayName')!.pristine &&
                                form.get('displayName')!.hasError('maxlength')"
                      [translateParams]="form.get('displayName')!.getError('maxlength')"
                      translate
                      class="errorMessage">
                upsert_folder_modal_form_name_max_warning
            </mat-hint>
        </mat-form-field>

        <mat-form-field>
            <input [placeholder]="'upsert_folder_form_description' | translate"
                   matInput
                   formControlName="description"
                   class="form-control"
                   data-cy="folder-description" />
            <mat-hint *ngIf="!form.get('description')!.pristine &&
                                form.get('description')!.hasError('maxlength')"
                      [translateParams]="form.get('description')!.getError('maxlength')"
                      translate
                      class="errorMessage">
                upsert_folder_modal_form_description_max_warning
            </mat-hint>
        </mat-form-field>

        <ng-container *uiModernContext>

            <div *ngIf="isRoot && isNewEntry"
                 class="radio-group-container">
                <label class="radio-label">
                    {{'upsert_folder_type' | translate}}
                </label>
                <mat-radio-group formControlName="type"
                                 data-cy="folder-type">
                    <mat-radio-button [value]="FolderType.Modern"
                                      data-cy="folder-type-modern">
                        <mat-icon class="ui-folder-icon-modern">folder_open</mat-icon>
                        {{ 'upsert_folder_modern' | translate }}
                        <mat-hint> – {{ 'upsert_folder_automatically_provisioned_robots' | translate }}</mat-hint>
                    </mat-radio-button>
                    <mat-radio-button [value]="FolderType.Classic"
                                      data-cy="folder-type-classic">
                        <mat-icon class="ui-folder-icon-classic">folder_open</mat-icon>
                        {{ 'upsert_folder_classic' | translate }}
                        <mat-hint> – {{ 'upsert_folder_manually_provisioned_robots' | translate }}</mat-hint>
                    </mat-radio-button>
                </mat-radio-group>
            </div>

            <div *ngIf="showRolesAssignmentOption"
                 class="radio-group-container">
                <label class="radio-label">
                    {{'upsert_folder_roles_assignment_model' | translate}}
                </label>
                <mat-radio-group formControlName="rolesAssignment"
                                 data-cy="roles-assignment">
                    <mat-radio-button [value]="RolesAssignment.CustomRoles"
                                      data-cy="roles-assignment-custom">
                        {{'upsert_folder_custom_roles' | translate}}
                    </mat-radio-button>
                    <mat-radio-button [value]="RolesAssignment.InheritFromTenant"
                                      data-cy="roles-assignment-inherit">
                        {{'upsert_folder_inherit_from_tenant' | translate}}
                    </mat-radio-button>
                </mat-radio-group>
            </div>

        </ng-container>
    </mat-dialog-content>

    <mat-dialog-actions *ngLet="{
                            loading: loading$ | async
                        } as state"
                        align="end">
        <button mat-dialog-close
                mat-button
                type="button">
            {{ 'modal_action_cancel' | translate }}
        </button>
        <button [spinnerButtonLoading]="state.loading"
                [disabled]="state.loading ||
                            !form.valid"
                mat-flat-button
                ui-spinner-button
                type="submit"
                color="primary"
                data-cy="submit">
            {{ (!isNewEntry ? 'modal_action_update' : 'modal_action_create') | translate }}
        </button>
    </mat-dialog-actions>
</form>
